import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faFile,
  faDownload,
  faFolderOpen,
  faSave,
  faUpload,
} from '@fortawesome/fontawesome-free-solid';
import { Link } from 'react-router-dom';
import logo from '../icon_white_transparent.svg';

function ToggleButton(props) {
  return (
    <button
      onClick={props.onClick}
      className={`btn btn-outline-dark  ${props.active ? 'bg-secondary text-white' : 'text-dark'}`}
    >
      {props.children}
    </button>
  );
}

export default class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    // this.props.song = exampleSong;
    this.state = {
      showOpenDropDown: false,
    };

    this.changeValue = this.changeValue.bind(this);
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.handleHide = this.handleHide.bind(this);
  }

  changeValue(event) {
    event.preventDefault();
    const newState = Object.assign({}, this.state);
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  }
  toggleDropDown(event) {
    event.preventDefault();
    this.setState(Object.assign({}, this.state, {
      showOpenDropDown: !this.state.showOpenDropDown,
    }));
  }

  handleHide() {
    if (this.props.onSidebarSetOpen) {
      this.props.onSidebarSetOpen(false);
    }
  }

  hideThenHandle(e, func) {
    this.handleHide();
    func(e);
  }

  render() {
    const branding = (
      <Link
        to="/"
        className="list-group-item text-center"
        onClick={this.handleHide}
        style={{
          background: '#ef6c00',
          color: '#fff',
        }}
      >
        {/* {this.props.song.meta.title} */}
        <img
          src={logo}
          style={{ height: '43px', filter: 'drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 1px)' }}
          className="mb-2"
          alt="logo"
        />
        <div className="text-body">
          <h5 className=" m-0 ">songwrite.app</h5>
          <div className="small">Proof of Concept</div>
        </div>
        {/* <span className="d-xs-none d-sm-inline d-md-none">SB</span> */}
      </Link>
    );
    return (
      <nav
        className="list-group list-group-flush sidebar"
        style={{ ...(this.props.style || {}), background: '#fff' }}
      >
        <div className="d-block d-md-none">{branding}</div>
        <div className="d-none d-md-block">{branding}</div>

        <a
          onClick={e => this.hideThenHandle(e, this.props.onNewSong)}
          className="list-group-item"
          href="#new"
        >
          <FontAwesomeIcon icon={faFile} />
          <span className="ml-3 ">New Song</span>
        </a>
        <Link to="/songs" className="list-group-item" onClick={this.handleHide}>
          <FontAwesomeIcon icon={faFolderOpen} />
          <span className="ml-3 ">Open Song...</span>
        </Link>
        <a
          className="list-group-item"
          onClick={e => this.hideThenHandle(e, this.props.onSave)}
          href="#save"
        >
          <FontAwesomeIcon icon={faSave} />
          <span className="ml-3 ">Save Song</span>
        </a>

        <a
          onClick={e => this.hideThenHandle(e, this.props.onDownload)}
          className="list-group-item"
          href="#download"
        >
          <FontAwesomeIcon icon={faDownload} />
          <span className="ml-3 ">Download</span>
        </a>
        <Link to="/upload-song" className="list-group-item" onClick={this.handleHide}>
          <FontAwesomeIcon icon={faUpload} />
          <span className="ml-3 ">Upload</span>
        </Link>
        {this.props.songlist.length > 0 && (
          <div className={` list-group-item dropdown${this.state.showOpenDropDown ? ' show' : ''}`}>
            <a
              className=" dropdown-toggle"
              href="#open"
              onClick={this.toggleDropDown}
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faFolderOpen} />
              <span className="ml-3 ">Open</span>
            </a>
            <div
              className={`dropdown-menu${this.state.showOpenDropDown ? ' show' : ''}`}
              aria-labelledby="navbarDropdown"
            >
              {this.props.songlist.map((filename, idx) => (
                <a
                  key={idx}
                  href="#filename"
                  className="dropdown-item"
                  onClick={e => this.hideThenHandle(e, e => this.props.onLoad(filename))}
                >
                  {filename}
                </a>
              ))}
            </div>
          </div>
        )}
        <div className="list-group-item">
          Show
          <div className="custom-control custom-checkbox">
            <input
              id="toolbarToggleIds"
              type="checkbox"
              checked={this.props.ui.toggles.ids}
              onChange={() => this.props.onToggleUI('ids')}
              className="custom-control-input"
            />
            <label className="custom-control-label" htmlFor="toolbarToggleIds">
              ID's
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              id="toolbarToggleSyllables"
              type="checkbox"
              checked={this.props.ui.toggles.syllables}
              onChange={() => this.props.onToggleUI('syllables')}
              className="custom-control-input"
            />
            <label className="custom-control-label" htmlFor="toolbarToggleSyllables">
              Syllables
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              id="toolbarToggleStresses"
              type="checkbox"
              checked={this.props.ui.toggles.stresses}
              onChange={() => this.props.onToggleUI('stresses')}
              className="custom-control-input"
            />
            <label className="custom-control-label" htmlFor="toolbarToggleStresses">
              Stresses
            </label>
          </div>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Toolbar.js